import api from '../api'
import cookies from 'vue-cookies'

export default {
  
  async login({ commit }, credentials) {
    try {
      /* //console.log("login credentials", credentials) */
      //localhost pour que api et front soient sur le même serveur
      const response = await api.post('/user/login', {
        username: credentials.username,
        password: credentials.password,
        admin: credentials.admin,
      });
      const token = response.data.TOKEN;
      const userData = response.data.userData;
      /* //console.log("Token", token);
      //console.log("userData", userData); */
      commit('setToken', token);
      commit('setUser', userData);
      commit('setAuthenticated', true);
      cookies.set('token', token);
      return response.data;
    } catch (error) {
      if (error.response) {
        commit('setStatusResponse', error.response.status);
      }
      //console.log("find out actual error.response :",error.response, "\terror.response.data : ", error.response?.data, "\terror.data", error.data)
      throw error.response?.data || error.data || 'Gestion des messages d\'erreurs ';
    }
  },

  async checkAuth({ commit }) {
    const token = cookies.get('token');
    //console.log("token : ", token)
    if (!token) {
      commit('clearAuth')
      commit('project/clearProjectState', null, { root: true })
      commit('referential/clearReferentialState', null, { root: true })
      return false;
    }

    try {
      
      /////////////////////////////////////////////////////////////////////////////////////////////////////////////////
      // TODO must add some verification about the reponses (to the commit for example) and redirection to 401 error //
      /////////////////////////////////////////////////////////////////////////////////////////////////////////////////
      
      /* //console.log("Sending request with token:", token); */
      
      // Fetch user data using the stored token
      const response = await api.get('/user/me');
      
      /* //console.log("!!!Received data while using /me:", response.data);
      //console.log("!!!Received userData while using /me:", response.data.userData); */
      
      // Save the user data in the store
      commit('setUser', response.data && response.data.userData);
      commit('setToken', token);
      commit('setAuthenticated', true);
      return true;
    } catch (error) {
      console.error('Failed to fetch user data:', error);
      commit('clearAuth')
      commit('project/clearProjectState', null, { root: true })
      commit('referential/clearReferentialState', null, { root: true })
      return false;
    }
  },

  async register(_, userData) {
  /* //console.log('userData reçu:', userData); */
    try {
      //localhost pour que api et front soient sur le même serveur
      const response = await api.post('/user/register', {
        username: userData.username,
        password: userData.password,
        name: userData.name,
        surname: userData.surname,
        email: userData.email,
        address: userData.address,
        company: userData.company,
        phone: userData.phone,
        mobile: userData.mobile,
        token: userData.token,
        locked: userData.locked,
      });
      
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  logout({ commit }) {
    cookies.remove('token');
    commit('clearAuth')
    commit('project/clearProjectState', null, { root: true })
    commit('referential/clearReferentialState', null, { root: true })
  },

  async fetchUserData({ commit }) {
      try{
        const {data} = await api.get(`user/my-info`);
        commit('setUserInfo', data.user_info);
        //console.log("Fetched user data:", data.user_info);
        return data.user_info
        }catch(error){
            console.error("Error fetching user data:", error)
            throw error.response?.data
        } 
    },
    
  async updateUserData({ commit }, payload){
    try {
      const { data } = await api.put(`user/my-info`, payload);
      commit('setUserInfo', data);
      //console.log("Updated user data:", data);
      return data
    }catch(error){
      console.error("Error updating user data:", error);
      throw error.response?.data;
    }
  },

  async fetchEmailAnswer({ commit }, token){
    try{
      const { data } = await api.post(`user/validate/${token}`)
      //console.log("email data: ", data)
      commit('fetchEmailAnswer', data)
      return data
    }catch(error){
      console.error("Not receiving the email answer");
      throw error.response?.data;
    }
  },
  
  async passwordRecovery(_, payload){
    try{
      //console.log("payload : ", payload)
      const { data } = await api.post(`user/recover`, payload)
      //console.log("password recovery data : ", data)
      return data;
    }catch(error){
      console.error("CAN'T RECOVER YOUR PASSWORD", error.response?.data)
      throw error.response?.data ||'Impossible de récupérer le mot de passe' ;
    }
  },

  async changePassword(_, payload){
    try{
      //console.log("[changePassword] payload :", payload)
      const { data } = await api.put(`user/password`, payload)
      return data
    }catch(error){
      console.error("Can't change password : ", error)
      throw error.response?.data || 'Changement de mot de passe impossible';
    }
  },
  
  /*   
  async deleteAccount({ commit }, credentials) {
    try {
      const response = await api.delete('/user/account', { data: credentials });
      commit('clearAuth');
      return response.data;
    } catch (error) {
      throw error.response?.data || 'Account deletion failed';
    }
  } */
}
